import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {map} from 'rxjs/operators';
import {BankCardPaymentFormInfo} from './bank-card-payment-form-info';

@Injectable({
  providedIn: 'root'
})
export class TopUpBalanceUsingBankCardService {

  constructor(
    private http: HttpClient
  ) { }

  public getAmountInBankCardCurrency(amount: number): Observable<number> {
    return this.http.post<any>(
      environment.apiBasepoint + 'top-up-balance-using-bank-card-convert-currency',
      {amount: amount},
      {observe: 'body'}
    ).pipe(
      map(result => result.amountInBankCardCurrency)
    );
  }
  public getAmountFromAmountInBankCardCurrency(amountInBankCardCurrency: number): Observable<number> {
    return this.http.post<any>(
      environment.apiBasepoint + 'top-up-balance-using-bank-card-convert-currency',
      {amountInBankCardCurrency: amountInBankCardCurrency},
      {observe: 'body'}
    ).pipe(
      map(result => result.amount)
    );
  }
  public prepareTransaction(amountInBankCardCurrency: number): Observable<BankCardPaymentFormInfo> {
    return this.http.post<any>(
      environment.apiBasepoint + 'top-up-balance-using-bank-card',
      {amountInBankCardCurrency: amountInBankCardCurrency},
      {observe: 'body'}
    );
  }
  public refreshTransactionStatus(url: string) {
    return this.http.post<any>(
      url,
      {},
      {observe: 'body'}
    );
  }
}
